import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackReviewsTab_GuestFeedbackFragment = { __typename?: 'GuestFeedback', id: string, text?: string | null, date: string, rating?: number | null, feedbackSource?: string | null, integrationLocation?: { __typename?: 'GuestFeedbackIntegrationLocation', id: string, sourceName?: string | null, sourceLocationId: string, location?: { __typename?: 'Location', id: number, name: string } | null } | null, csvUploadLocation?: { __typename?: 'GuestFeedbackCsvUploadLocation', id: string, locationName: string, location?: { __typename?: 'Location', id: number, name: string } | null } | null };

export type GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables = Types.Exact<{
  input: Types.GuestFeedbacksInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type GuestFeedbackReviewsTab_GuestFeedbacksQuery = { __typename?: 'Query', GuestFeedbacks: { __typename?: 'GuestFeedbacks', totalCount: number, objects: Array<{ __typename?: 'GuestFeedback', id: string, text?: string | null, date: string, rating?: number | null, feedbackSource?: string | null, integrationLocation?: { __typename?: 'GuestFeedbackIntegrationLocation', id: string, sourceName?: string | null, sourceLocationId: string, location?: { __typename?: 'Location', id: number, name: string } | null } | null, csvUploadLocation?: { __typename?: 'GuestFeedbackCsvUploadLocation', id: string, locationName: string, location?: { __typename?: 'Location', id: number, name: string } | null } | null }> } };

export const GuestFeedbackReviewsTab_GuestFeedbackFragmentDoc = gql`
    fragment GuestFeedbackReviewsTab_GuestFeedback on GuestFeedback {
  id
  text
  date
  rating
  feedbackSource
  integrationLocation {
    id
    sourceName
    sourceLocationId
    location {
      id
      name
    }
  }
  csvUploadLocation {
    id
    locationName
    location {
      id
      name
    }
  }
}
    `;
export const GuestFeedbackReviewsTab_GuestFeedbacksDocument = gql`
    query GuestFeedbackReviewsTab_GuestFeedbacks($input: GuestFeedbacksInput!, $pagination: PaginationInput) {
  GuestFeedbacks(input: $input, pagination: $pagination) {
    objects {
      ...GuestFeedbackReviewsTab_GuestFeedback
    }
    totalCount
  }
}
    ${GuestFeedbackReviewsTab_GuestFeedbackFragmentDoc}`;

/**
 * __useGuestFeedbackReviewsTab_GuestFeedbacksQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackReviewsTab_GuestFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackReviewsTab_GuestFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackReviewsTab_GuestFeedbacksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGuestFeedbackReviewsTab_GuestFeedbacksQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackReviewsTab_GuestFeedbacksQuery, GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables> & ({ variables: GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackReviewsTab_GuestFeedbacksQuery, GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables>(GuestFeedbackReviewsTab_GuestFeedbacksDocument, options);
      }
export function useGuestFeedbackReviewsTab_GuestFeedbacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackReviewsTab_GuestFeedbacksQuery, GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackReviewsTab_GuestFeedbacksQuery, GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables>(GuestFeedbackReviewsTab_GuestFeedbacksDocument, options);
        }
export type GuestFeedbackReviewsTab_GuestFeedbacksQueryHookResult = ReturnType<typeof useGuestFeedbackReviewsTab_GuestFeedbacksQuery>;
export type GuestFeedbackReviewsTab_GuestFeedbacksLazyQueryHookResult = ReturnType<typeof useGuestFeedbackReviewsTab_GuestFeedbacksLazyQuery>;
export type GuestFeedbackReviewsTab_GuestFeedbacksQueryResult = Apollo.QueryResult<GuestFeedbackReviewsTab_GuestFeedbacksQuery, GuestFeedbackReviewsTab_GuestFeedbacksQueryVariables>;